<template>
  <v-dialog
    v-model="value.show"
    @input="(v) => v || closeAction()"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
          value.mode === "edit" ? $t("editfleet") : $t("createfleet")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="editCreateForm">
          <v-container grid-list-sm>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field
                  name="id"
                  :label="$t('number')"
                  type="number"
                  v-model="fleet.id"
                  v-validate="'required|numeric'"
                  :data-vv-as="$t('id')"
                  :error-messages="errors.collect('id')"
                  :readonly="value.mode === 'edit'"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  name="name"
                  :label="$t('name')"
                  type="text"
                  v-model="fleet.name"
                  v-validate="'required|max:255'"
                  :data-vv-as="$t('name')"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  name="dsu"
                  :label="$t('dsu')"
                  type="text"
                  v-model="fleet.dsu"
                  v-validate="'max:255'"
                  :data-vv-as="$t('dsu')"
                  :error-messages="errors.collect('dsu')"
                ></v-text-field>
              </v-flex>
              
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="closeAction"
          :disabled="value.formDisabled"
          >{{ $t("close") }}</v-btn
        >
        <v-btn
          color="blue darken-1"
          flat
          @click.native="saveAction"
          :disabled="value.formDisabled"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_FLEET,
  CREATE_FLEET,
  RESET_FLEET,
  SHOW_SNACKBAR,
} from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";

export default {
  props: ["value", "existingFleetIds"],
  data() {
    return {
      formDisabled: false,
    };
  },
  computed: {
    ...mapGetters(["fleet"]),
  },
  mixins: [validationErrorsMixin],
  methods: {
    saveAction() {
      // Sprawdzenie, czy fleet.id już istnieje w existingFleetIds
      if (
        this.value.mode === "create" &&
        this.existingFleetIds.includes(Number(this.fleet.id))
      ) {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("fleetIdAlreadyExists"),
          color: "error",
        });
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.formDisabled = true;

          this.$store
            .dispatch(
              this.value.mode === "edit" ? UPDATE_FLEET : CREATE_FLEET,
              this.fleet
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("fleet")]),
                color: "success",
              });

              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", {
        mode: this.value.mode,
        show: false,
      });
      this.formDisabled = false;
      // we need wait for animation until is finished
      setTimeout(() => {
        this.$store.dispatch(RESET_FLEET);
        this.$refs.editCreateForm.reset();
        this.$validator.reset();
      }, 100);
    },
  },
};
</script>

<style scoped></style>
